import { Switch, Route } from "react-router";

import PositionOverview from "../../features/position-overview";
import AircraftOverview from "../../features/aircraft-overview";
import CrewOverview from "../../features/crew-course-overview";
import CrewSubscriptions from "../../features/crew-subscriptions";
import UsersList from "../../features/users-list";
import PendingCertificates from "../../features/pending-certificates";
import BulkCertificateUploadPage from "../../features/bulk-certificate-upload";
import UserCoursesBulkUploadPage from "../../features/bulk-certificate-upload/UserCoursesBulkUploadPage";
import CustomCourseAdd from "../../features/custom-courses-add";
import CustomCoursesTable from "../../features/custom-courses-table";
import MoodleCoursesTable from "../../features/moodle-courses-table";
import MoodleCourseEdit from "../../features/moodle-course";
import CrewAircraft from "../../features/crew-aircraft";
import ShoppingCart from "../../features/shopping-cart";
import MemberEdit from "../member-edit";
import UserCompliance from "../../features/compliance";
import Members from "../../features/members";
import { WithPermission } from "../../components/Authorization";
import FeatureFlagRoute from "../../components/FeatureFlagRoute";
import { FEATURE_FLAGS } from "../../hooks/useFeatureFlag";
import { PERMISSIONS } from "../../constants";

const CrewPage = ({ match, history }) => (
  <Switch>
    <Route path={`${match.path}/:crewId/cart`} component={ShoppingCart} />
    <Route
      path={[`${match.path}/:crewId/customCourses/add`, `${match.path}/:crewId/customCourses/edit/:courseId`]}
      component={CustomCourseAdd}
    />
    <Route path={`${match.path}/:crewId/customCourses`} component={CustomCoursesTable} />

    <Route exact path={`${match.path}/:crewId/moodle`} component={MoodleCoursesTable} />
    <Route exact path={`${match.path}/:crewId/moodle/add`} component={MoodleCourseEdit} />
    <Route exact path={`${match.path}/:crewId/moodle/edit/:courseId`} component={MoodleCourseEdit} />

    <Route
      exact
      path={`${match.path}/:crewId/companyCourses`}
      render={(props) => (
        <WithPermission permission={PERMISSIONS.CONFIGURE_COMPANY_LMS_COURSE}>
          <MoodleCoursesTable {...props} isCompanyCourse={true} />
        </WithPermission>
      )}
    />
    <Route
      exact
      path={`${match.path}/:crewId/companyCourses/add`}
      render={(props) => (
        <WithPermission permission={PERMISSIONS.CONFIGURE_COMPANY_LMS_COURSE}>
          <MoodleCourseEdit {...props} isCompanyCourse={true} />
        </WithPermission>
      )}
    />
    <Route
      exact
      path={`${match.path}/:crewId/companyCourses/edit/:courseId`}
      render={(props) => (
        <WithPermission permission={PERMISSIONS.CONFIGURE_COMPANY_LMS_COURSE}>
          <MoodleCourseEdit {...props} isCompanyCourse={true} />
        </WithPermission>
      )}
    />

    <Route path={`${match.path}/:crewId/pending`} component={PendingCertificates} />
    <Route
      exact
      path={`${match.path}/:crewId/bulk-upload/user-courses`}
      render={(props) => (
        <WithPermission permission={PERMISSIONS.BULK_UPLOAD_CERTIFICATES}>
          <UserCoursesBulkUploadPage {...props} />
        </WithPermission>
      )}
    />
    <Route
      exact
      path={`${match.path}/:crewId/bulk-upload`}
      render={(props) => (
        <WithPermission permission={PERMISSIONS.BULK_UPLOAD_CERTIFICATES}>
          <BulkCertificateUploadPage {...props} />
        </WithPermission>
      )}
    />
    <Route path={`${match.path}/:crewId/subscriptions`} component={CrewSubscriptions} />

    <Route path={`${match.path}/:crewId/position-overview`} component={PositionOverview} />
    <FeatureFlagRoute
      path={`${match.path}/:crewId/aircraft-overview`}
      flag={FEATURE_FLAGS.AIRCRAFT_OPS}
      component={AircraftOverview}
      redirectTo={(props) => `${match.path}/${props.match.params.crewId}/position-overview`}
    />
    <Route path={`${match.path}/:crewId/overview`} component={CrewOverview} />
    <Route
      path={`${match.path}/:crewId/members/:userId/compliance/:pageId`}
      render={(props) => <UserCompliance {...props} showBackButton={true} />}
    />
    <Route path={`${match.path}/:crewId/members/:userId/edit`} component={MemberEdit} />
    <Route path={`${match.path}/:crewId/users`} component={UsersList} />
    <Route path={`${match.path}/:crewId/members`} component={Members} />
    <Route path={`${match.path}/:crewId/aircraft`} component={CrewAircraft} />
  </Switch>
);

export default CrewPage;
